import { ChiptaElement, html } from 'chipta-libs/main.js';
import { clickIsInside } from 'chipta-libs/utils/dom.js';


class OutsideClick extends ChiptaElement {

  render() {

    /*
     * NOTE: The <slot> element needs a container (the `slot-container`), other
     * than a custom element. Otherwise it won't render in webcomponent
     * polyfilled browsers (like IE).
     */

    return html`

      <div id="slot-container">
        <slot></slot>
      </div>

      <style>

        :host {
          display: block;
        } 

      </style>

    `;

  }

  connectedCallback() {
    super.connectedCallback();
    this.addOnClickListener();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeOnClickListener();
  }

  addOnClickListener() {

    this.onClickListener = event => {
      if (!clickIsInside(event, this)) {
        this.triggerEvent('outside-click');
      }
    };

    // Use `setTimeout` to add the listener at the next event cycle. This
    // prevents the outside click event from firing when the component was
    // created by a click itself.
    setTimeout(() => {
      document.addEventListener('click', this.onClickListener);
    });

  }

  removeOnClickListener() {
    document.removeEventListener('click', this.onClickListener);
  }

}

customElements.define('outside-click', OutsideClick);
